import { ValidationLengthUnder254, ValidationMailAddressEmptyOk } from '../../../model/validation';
import { Input } from './input';
import { Validation } from '../../../model/validation/validation';

type Props = {
  className?: string;
  value: string | undefined;
  onChange: (v: string) => void;
  require?: boolean
  touch?: boolean
  disabled?: boolean;
  noValidation?:boolean
}

export const InputMail = (props: Props) => {
  const {
    value = '',
    onChange: _onChange,
    noValidation,
  } = props;

  const onChange = (v:string) => {
    const isMatch = v.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/);
    if (isMatch) {
      _onChange(v);
    }
  };

  return (
    <Input
      {...props}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      validationList={noValidation
        ? undefined
        : [
          ...ValidationMailAddressEmptyOk,
          ...ValidationLengthUnder254,
        ]}
      maxLength={254}
      type="email"
    />
  );
};
